import React from 'react';

// Lets editors force a manual line break from Sanity by pressing Enter
// (rendered as a newline in the string) instead of relying on text wrapping.
export const renderWithLineBreaks = (text) => {
  if (!text) return text;

  return text.split('\n').map((line, index, lines) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ));
};
